export function average(data: Array<number>): number {
  return data.reduce((a, b) => a + b, 0) / data.length
}

export function stdDev(data: Array<number>): number {
  const avg = average(data)

  const squareDiffs = data.map((value) => {
    const diff = value - avg
    const sqrDiff = diff * diff
    return sqrDiff
  })

  const avgSquareDiff = average(squareDiffs)

  const standardDev = Math.sqrt(avgSquareDiff)
  return standardDev
}
